const IframePreview = ({node}) => {
  const {url} = node;
  return <iframe src={url} width="100%" height="600"></iframe>;
};

export default IframePreview;
